var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgMobileOwners(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    stroke: "#98A1BD",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10.333 11.429a3.571 3.571 0 100-7.143 3.571 3.571 0 000 7.143zM15.062 15.357a7.142 7.142 0 00-9.457 0M19.62 15v2.857a1.429 1.429 0 01-1.43 1.429h-2.857M15.333.714h2.857a1.429 1.429 0 011.43 1.429V5M1.048 5V2.143A1.429 1.429 0 012.476.714h2.857M5.333 19.286H2.476a1.429 1.429 0 01-1.428-1.429V15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMobileOwners;